// Portions of this file are Copyright 2021 Google LLC, and licensed under GPL2+. See COPYING.

import { Symlinks } from "./filesystem";

export type ZipArchives = {
  [name: string]: {
    deployed?: boolean,
    description?: string,
    gitOrigin?: {
      repoUrl: string,
      branch: string,
      include: {
        glob: string | string[],
        ignore?: string | string[],
        replacePrefix?: {[path: string]: string},
      }[]
    }
    symlinks?: Symlinks,
    docs?: {[name: string]: string}
  }
};

export const zipArchives: ZipArchives = {
  'fonts': {},
  'grafik': {
    description: 'grafik printing press',
    gitOrigin: {
      branch: 'main',
      repoUrl: 'https://git.freemasen.com/freemasen/grafik',
      include: [{glob: ['*.scad']}],
    },
  },
};

export const deployedArchiveNames =
  Object.entries(zipArchives)
    .filter(([_, {deployed}]) => deployed == null || deployed)
    .map(([n]) => n);
